import { styled, ListItemButton } from '@mui/material'

export const StyledMemoryListItem = styled(ListItemButton)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
  borderRadius: theme.spacing(1.5),
  marginBottom: theme.spacing(1),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  transition: 'background-color 0.2s',

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}))
